"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useAsyncBatcher = require("./useAsyncBatcher.cjs");
function useAsyncBatchedCallback(fn, options) {
  const asyncBatchedFn = useAsyncBatcher.useAsyncBatcher(fn, options).addItem;
  return react.useCallback(
    async (...args) => {
      asyncBatchedFn(args[0]);
    },
    [asyncBatchedFn]
  );
}
exports.useAsyncBatchedCallback = useAsyncBatchedCallback;
//# sourceMappingURL=useAsyncBatchedCallback.cjs.map
